import { IsNotEmpty, IsAlphanumeric, MaxLength, Matches, IsOptional, IsNumber } from 'class-validator';
import { ApiProperty } from '@nestjs/swagger';

export class SkuDataRequest {
    @ApiProperty()
    @IsNotEmpty()
    @IsAlphanumeric()
    skuCodeId: number;

    @ApiProperty()
    @IsOptional()
    foodTypeId: number;

    @ApiProperty()
    @IsOptional()
    @IsNumber()
    soakingStyle: string;

}